export const capFirst = (s: string) => s.replace(/./, (c) => c.toUpperCase());
